import{isSequenceEqual as e}from"../isSequenceEqual";export var compareProgressEvents=function(r,n){return e(r.bufferedRanges,n.bufferedRanges)};